import React from 'react'
import StyledH3Heading from '../../../common/components/styledH3Heading/StyledH3Heading'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import Button from '../../../components/button/Button'
import LinkedButton from '../../../components/linkedButton/LinkedButton'

const SecuredSection = () => {
    return (
        <div className='w-[95%] flex lg:flex-row gap-5 lg:gap-0 flex-col-reverse items-center'>
            <div className='lg:w-[50%]'>
                <img src='/assets/images/securedSection-polygon.webp' alt='Polygon' />
            </div>
            <div className='lg:w-[45%] flex flex-col items-center lg:items-start gap-8'>
                <div className='text-center lg:text-right'>
                    <StyledH3Heading fontColor="text-gradient">Secured by the Polygon.</StyledH3Heading>
                </div>
                <div>
                    <StyledMdText fontColor="text-white text-center lg:text-right">In return for securing the services on the HopeLedger Hub, transaction fees and staking rewards are distributed to the NGO's and needy.</StyledMdText>
                </div>
                <div className='flex justify-end w-full gap-5 pt-5'>
                    <div className='w-[50%] lg:w-[40%]'>
                        <Button fontColor="text-black" variant="button-gradient">Start Staking</Button>
                    </div>
                    <div className='w-[50%] lg:w-[40%]'>
                        <LinkedButton link="www.google.com" target="true" fontColor="text-white">Learn More</LinkedButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SecuredSection
